// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @bitwarden/platform/no-enums
export enum ProductType {
  PasswordManager = 0,
  SecretsManager = 1,
}
